import React, {Component, useEffect, useState} from 'react';
import {Form, Dropdown} from "react-bootstrap";
import {FaCheckCircle, FaFolderOpen, FaRegCircle, FaSpinner, FaTimesCircle, FaTrashAlt} from "react-icons/fa";
import {Storage} from "@aws-amplify/storage";
import {SectionsContext} from "../../contexts/SectionsProvider";
import {DataStore} from "@aws-amplify/datastore";
import {UserMortgage, UserMortgageUploads} from "../../../models";
import Tooltip from "./Tooltop";
import ConfirmDelete from "./ConfirmDelete";
function UploaderRow (props){
    const [state,setState] = useState({
            percent: 0,
            error: false
    })
    const getFile = async()=>{
        const result = await Storage.get(getFileStorageName(), {
            level: 'protected'
        });
        console.log(result)
        props.setViewing(result,props.model.contentType)
    }
    const getFileStorageName = ()=>{
        let mID = props.model?.mortgageID ? props.model.mortgageID : props.model.mortgage.id
        let namingConvention = mID + '/' + props.model.section + '/'
        if (props.model.index){
            namingConvention +=  props.model.index + '/'
        }
        namingConvention += props.model.id
        return namingConvention
    }
    const formControlAttr = {
        defaultValue: props.model.fileName,
    }
    useEffect(()=>{
        if (props.file) {
            let progressTimer
            const config = {
                contentType: props.file.type,
                level: "protected",
                resumable: true,
                progressCallback: (progress) => {
                    //console.log('progress',progress)
                    clearTimeout(progressTimer)
                    progressTimer = setTimeout(() => {
                        setState({percent: ((progress.loaded / progress.total) * 100).toFixed(0)})
                    }, 100)
                },
                completeCallback: (event) => {
                    //console.log(`Successfully uploaded ${event.key}`);
                    props.onComplete(props.model)
                },
                errorCallback: (err) => {
                    setState({error: true})
                    console.error('Unexpected error while uploading', err);
                }
            }
            try {
                Storage.put(getFileStorageName(), props.file, config);
            } catch (error) {
                setState({error: true})
                console.log("Error uploading file: ", error);
            }
        }
    },[props.file])
    if (!props.editMode) {
        formControlAttr.className = 'ps-3'
        formControlAttr.readOnly = true
        formControlAttr.plaintext = true
    } else {
        formControlAttr['data-id'] = props.model.id
        formControlAttr.onBlur = props.handleNameChange
    }
    return (
        <tr className={`transitionable delay-${props.loopIndex}`}>
            <td className="ps-4 font-weight-bold align-middle">
                {1 + props.loopIndex}
            </td>
            <td className="align-middle w-100">
                <Form.Control key={formControlAttr.defaultValue} {...formControlAttr} />
            </td>
            <td className="align-middle">
                {state.error && (
                    <span
                        className="badge bg-danger d-flex align-items-center"> <FaTimesCircle
                        className="me-1 fa-fw"/> Failed </span>
                )}
                {
                    !state.error && (
                        <>
                            {props.model.status === 'ACCEPTABLE' && (<span
                                className="badge lh-1 bg-success d-flex align-items-center"> <FaCheckCircle
                                className="me-1 fa-fw"/> OK </span>)}
                            {props.model.status === 'REJECTED' && (
                                <Tooltip body={props.model.reason}>
                                        <span
                                            className="badge bg-danger d-flex align-items-center"> <FaTimesCircle
                                            className="me-1 fa-fw"/> Rejected </span>
                                </Tooltip>
                            )}
                            {props.model.status === 'PENDING' && (<span
                                className="badge bg-info d-flex align-items-center"> <FaRegCircle
                                className="me-1 fa-fw"/> Under Review </span>)}
                            {props.model.status === 'UPLOADING' && (<span
                                    className="badge bg-warning d-flex align-items-center">

                                    <FaSpinner className="spinning me-1 fa-fw"/> Uploading </span>
                            )}
                        </>
                    )
                }
            </td>
            <td className="text-right align-middle pe-4" style={{width: 'auto'}}>
                <div className='d-flex justify-content-end align-items-center'>
                    {props.model.status !== 'UPLOADING' && (
                        <a onClick={getFile} title="Open" className="text-info">
                            <FaFolderOpen size={20}/>
                        </a>)
                    }
                    {props.editMode && (
                        <ConfirmDelete onDelete={props.handleDelete} id={props.model.id} className="btn btn-secondary">
                            <FaTrashAlt className="text-warning"/>
                        </ConfirmDelete>
                    )}
                </div>
            </td>
        </tr>
    )

}

class UploaderRow1 extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.observer= null
        this.state = {
            percent: 0,
            error: false
        }
    }
    componentDidMount() {
        if (this.props.file) {
            let progressTimer
            const config = {
                contentType: this.props.file.type,
                level: "protected",
                resumable: true,
                progressCallback: (progress) => {
                  // console.log(progress)
                    clearTimeout(progressTimer)
                    progressTimer = setTimeout(() => {
                        this.setState({percent: ((progress.loaded / progress.total) * 100).toFixed(0)})
                    }, 100)
                },
                completeCallback: (event) => {
                   // console.log(`Successfully uploaded ${event.key}`);
                    this.props.onComplete(this.props.model)
                },
                errorCallback: (err) => {
                    this.setState({error: true})
                    console.error('Unexpected error while uploading', err);
                }
            }
            try {
                Storage.put(this.getFileStorageName(), this.props.file, config);
            } catch (error) {
                this.setState({error: true})
                console.log("Error uploading file: ", error);
            }
        }
    }
    getFileStorageName = ()=>{
        let mID = this.props.model?.mortgageID ? this.props.model.mortgageID : this.props.model.mortgage.id
        let namingConvention = mID + '/' + this.props.model.section + '/'
        if (this.props.model.index){
            namingConvention +=  this.props.model.index + '/'
        }
        namingConvention += this.props.model.id
        return namingConvention
    }
    getFile = async()=>{
        const result = await Storage.get(this.getFileStorageName(), {
            level: 'protected'
        });
        this.props.setViewing(result,this.props.model.contentType)
    }
    render() {
        if (this.props.file) {
            //console.log(this.props.model)
        }
        const formControlAttr = {
            defaultValue: this.props.model.fileName,
        }
        if (!this.props.editMode) {
            formControlAttr.className = 'ps-3'
            formControlAttr.readOnly = true
            formControlAttr.plaintext = true
        } else {
            formControlAttr['data-id'] = this.props.model.id
            formControlAttr.onBlur = this.props.handleNameChange
        }
        return (
            <tr>
                <td className="ps-4 font-weight-bold align-middle">
                    {1 + this.props.loopIndex}
                </td>
                <td className="align-middle w-100">
                    <Form.Control key={formControlAttr.defaultValue} {...formControlAttr} />
                </td>
                <td className="align-middle">
                    {this.state.error && (
                        <span
                            className="badge bg-danger d-flex align-items-center"> <FaTimesCircle
                            className="me-1 fa-fw"/> Failed </span>
                    )}
                    {
                        !this.state.error && (
                            <>
                                {this.props.model.status === 'ACCEPTABLE' && (<span
                                    className="badge lh-1 bg-success d-flex align-items-center"> <FaCheckCircle
                                    className="me-1 fa-fw"/> OK </span>)}
                                {this.props.model.status === 'REJECTED' && (
                                    <Tooltip body={this.props.model.reason}>
                                        <span
                                            className="badge bg-danger d-flex align-items-center"> <FaTimesCircle
                                            className="me-1 fa-fw"/> Rejected </span>
                                    </Tooltip>
                                    )}
                                {this.props.model.status === 'PENDING' && (<span
                                    className="badge bg-info d-flex align-items-center"> <FaRegCircle
                                    className="me-1 fa-fw"/> Under Review </span>)}
                                {this.props.model.status === 'UPLOADING' && (<span
                                        className="badge bg-warning d-flex align-items-center">

                                    <FaSpinner className="spinning me-1 fa-fw"/> Uploading </span>
                                )}
                            </>
                        )
                    }
                </td>
                <td className="text-right align-middle pe-4" style={{width: 'auto'}}>
                    <div className='d-flex justify-content-end'>
                        {this.props.model.status !== 'UPLOADING' && (
                            <a onClick={this.getFile} title="Open" className="text-info">
                                <FaFolderOpen size={20}/>
                            </a>)
                        }
                        {this.props.editMode && (
                            <Dropdown className="d-inline ms-3">
                                <Dropdown.Toggle as="a" id="dropdown-autoclose-true" className="no-caret">
                                    <FaTrashAlt className="text-warning"/>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.ItemText className="text-nowrap w-100 text-center"><h5>Are you sure?</h5></Dropdown.ItemText>
                                    <div className="d-flex mx-2 dropdown-delete">
                                        <Dropdown.Item className="m-1 btn btn-light text-nowrap">Cancel</Dropdown.Item>
                                        <Dropdown.Item data-id={this.props.model.id} onClick={this.props.handleDelete} className="m-1 btn btn-danger text-nowrap text-danger">Delete</Dropdown.Item>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                    </div>
                </td>
            </tr>
        )
    }
}
export default UploaderRow;